import { useState, useEffect } from "react";
import { DataFeedInstance } from "../../chart-datafeed/udf-compatible-datafeed";
import type { ResolveSymbolInfo } from "../../models/symbolData";

const useLiveResolveSymbol = (symbol: string): { symbolInfo: ResolveSymbolInfo | null, loading: boolean, error: string | null } => {
  const [symbolInfo, setSymbolInfo] = useState<ResolveSymbolInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!symbol) {
      return;
    }

    setLoading(true);
    setError(null);

    const resolveSymbol = () => {
      try {
        DataFeedInstance?.resolveSymbol(
          String(symbol),
          (resolvedSymbolInfo: ResolveSymbolInfo) => {
            // Successfully received the resolved symbol info
            setSymbolInfo(resolvedSymbolInfo);
            setLoading(false);
          },
          (err) => {
            // Handle error in resolving the symbol
            console.error("Error resolving symbol:", err);
            setError("Failed to resolve symbol.");
            setLoading(false);
          },
          '' // This can be left as is, unless you need a specific value
        );
      } catch (err) {
        console.error("Error resolving symbol:", err);
        setError("Failed to resolve symbol.");
        setLoading(false);
      }
    };

    resolveSymbol();
  }, [symbol]);

  return { symbolInfo, loading, error };
};

export default useLiveResolveSymbol;
